import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../models/dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class TicketSeatColorComponent extends Component {
  static readonly TYPE_ID = 'f00dd7fc164e4c6f89717da232aa0146';

  private constructor(
    public readonly color: number,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return TicketSeatColorComponent.TYPE_ID;
  }

  static create(args: { color: number }): TicketSeatColorComponent {
    return new TicketSeatColorComponent(args.color);
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketSeatColorComponent {
    return this.create({
      color: MapUtils.getNumber(map, 'color'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      color: this.color,
    };
  }

  clone(): this {
    return TicketSeatColorComponent.create({
      color: this.color,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.color === this.color;
  }
}

export class TicketSeatColorComponentBuilder extends DataModelBuilder<TicketSeatColorComponent> {
  build(context: SerializationContext, map: SerializedData): TicketSeatColorComponent {
    return TicketSeatColorComponent.fromMap(context, map);
  }
}
